module.exports = __webpack_public_path__ + "img/84.17a725e6.jpg";